const KIND_LABELS: Record<GQL_PlacePageKind, string> = {
  town: 'Town',
  point_of_interest: 'Point of interest',
}

const kindLabel = (kind: GQL_PlacePageKind): string => KIND_LABELS[kind]

export default kindLabel
